export const FOOTER_LINKS = [
	{
		translation_key_title: 'our_branches',
		links: [],
	},
	{
		translation_key_title: 'renting_at_the_airport',
		links: [],
	},
	{
		translation_key_title: 'onther_locations_in_poland',
		links: [],
	},
]
